

<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="calc(80% - 0px)" center
        :close-on-click-modal="false" :before-close="handleClose" append-to-body>
        <div>
            <template>
                <pre style="white-space: pre-wrap; max-height: 700px; overflow-y: auto;">
                    {{ logContent }}
                </pre>
            </template>
        </div>
    </el-dialog>
</template>

<script>
import { BASE_LOG_URI } from '../../utils/options'
import axios from 'axios'

  export default {
    name: "fileviewer",
    data() {
      return {
            loadingPage: false,
            dialogVisible: false,
            dialogTitle: '',
            logContent: '',
      }
    },
    methods: {
        handleClose() {
            if(this.socket){
                this.socket.close()
            }
            this.dialogVisible = false
            this.loadingPage = false
        },
        logViewFlagFn(data, flag){
            this.dialogTitle=flag
            this.dialogVisible=true

            let url= BASE_LOG_URI + data.file_path

            axios.post('remote-log-file-list/ws-ticket/').then((response) => {
                const ticket = response.data.ticket
                this.setup_websocket(url + '/?ticket=' + encodeURIComponent(ticket), data.file_path)
            })
            // this.fetchLog(url)
        },
        async setup_websocket(url, file_path){
            this.socket = new WebSocket(url);

            this.socket.onopen = () => {
                console.log('WebSocket connection opened');
                if (this.socket.readyState === WebSocket.OPEN) {
                    this.socket.send(file_path);
                } else {
                    console.error('WebSocket is not open');
                }
            };

            this.socket.onmessage = (event) => {
                console.log('websocket receive message')
                const data = JSON.parse(event.data);
                this.logContent = data.logs;
            };

            this.socket.onclose = () => {
                console.log('WebSocket connection closed');
            };
        },
        async fetchLog(uri) {
            try {
                const response = await fetch(uri);
                const text = await response.text();
                this.logContent = text;

                setTimeout(()=>{
                    if(this.dialogTitle){
                        this.fetchLog(uri)
                    }
                }, 1000)
            } catch (error) {
                console.error('Error fetching log:', error);
            }
        },
    }
  }
</script>
